import angular from 'angular';
import { onInitialized } from './on-initialized.directive';


export const onInitializedModule = angular
	.module('onInitialized', [])
	.directive('onInitialized', onInitialized)
	.name;
